/**
 * Cloudflare Turnstile — browser script loader
 */

import { TURNSTILE_SCRIPT_URL } from '../constants/turnstile.js'

const SCRIPT_DATA_ATTR = 'data-viva-turnstile'

let scriptPromise = null

/**
 * Load Turnstile API once per page (explicit render mode).
 * @returns {Promise<void>}
 */
export function loadTurnstileScript () {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Turnstile is only available in the browser'))
  }
  if (window.turnstile) {
    return Promise.resolve()
  }
  if (scriptPromise) {
    return scriptPromise
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[${SCRIPT_DATA_ATTR}]`)
    if (existing) {
      if (window.turnstile) {
        resolve()
        return
      }
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject(new Error('Failed to load Turnstile')))
      return
    }

    const script = document.createElement('script')
    script.src = TURNSTILE_SCRIPT_URL
    script.async = true
    script.defer = true
    script.setAttribute(SCRIPT_DATA_ATTR, '')
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load Turnstile'))
    document.head.appendChild(script)
  })

  return scriptPromise
}
